import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import { GetNotificationsResponse } from './useGetNotifications';

interface ToggleNotificationsResponse {
    notificationsEnabled: boolean;
}

const toggleNotifications = async (sessionId: string | null): Promise<ToggleNotificationsResponse> => {
    const response = await axios.patch(
        `${API_URL}/notifications/toggle`,
        {},
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
    return response.data;
};

export const useToggleNotifications = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => toggleNotifications(sessionContext?.sessionId ?? null),
        onSuccess: (data) => {
            // Update the notifications query cache with new enabled state
            queryClient.setQueriesData(
                { queryKey: ['/notifications'] },
                (oldData: GetNotificationsResponse | undefined) => {
                    if (!oldData) return oldData;
                    return {
                        ...oldData,
                        notificationsEnabled: data.notificationsEnabled
                    };
                }
            );
            // Also invalidate profile query so Profile page updates
            queryClient.invalidateQueries({ queryKey: ['profile'] });
        },
    });
};
